/** Preserve an alert destination through password and MFA login. */
export const adminReturnTo = (from: any): string => {
  if (!['/flag-review', '/conversations'].includes(from?.pathname)) return '/dashboard';
  return from.pathname + (typeof from.search === 'string' && from.search.startsWith('?') ? from.search : '');
};
